import { defaultIconProps, IconProps } from './IconProps';

export const IconPlayFill: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M1 1L15 10L1 19V1Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconPlayFill.defaultProps = defaultIconProps;
